import React from "react";
import { toast } from "sonner";
import { useAdminAuth } from "@/hooks/useAdminAuth";
import { useAdminList } from "@/hooks/useAdminList";
import AdminTable from "@/components/admin/AdminTable";

const formatDate = (iso) =>
  new Date(iso).toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });

const COLUMNS = [
  { key: "email", label: "E-mail" },
  { key: "created_at", label: "Inscrito em", render: (r) => formatDate(r.created_at) },
];

export default function AdminNewsletter() {
  const { pin } = useAdminAuth();
  const { items, loading, error, remove } = useAdminList("/newsletter", pin);

  const handleDelete = async (row) => {
    if (!window.confirm(`Remover a inscrição de ${row.email}?`)) return;
    try {
      await remove(row.id);
      toast.success("Inscrição removida");
    } catch {
      toast.error("Falha ao remover");
    }
  };

  return (
    <div className="p-6 lg:p-10">
      <div className="mb-6">
        <span className="mn-eyebrow">Newsletter</span>
        <h2 className="font-serif-display font-extrabold text-2xl text-[var(--mn-black)] mt-3">
          {items.length} inscrito(s)
        </h2>
      </div>
      <AdminTable
        columns={COLUMNS}
        rows={items}
        loading={loading}
        error={error}
        emptyLabel="Nenhuma inscrição na newsletter ainda."
        onDelete={handleDelete}
        getRowTestId={(r) => `admin-newsletter-${r.id}`}
      />
    </div>
  );
}
